import React from 'react'

import Center from '../helpers/Center'
import Icon from '../shapes/Icon'
import Link from './Link'

const IconLink = ({ onClick, to, ...props }) => (
  <Link block onClick={onClick} to={to}>
    <Center>
      <Icon {...props} />
    </Center>
  </Link>
)

export default IconLink
